import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FaExclamationTriangle } from 'react-icons/fa';
const StatsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
const StatCard = styled.div `
  background: linear-gradient(135deg,
    ${props => props.$color}15 0%,
    ${props => props.$color}05 100%
  );
  border: 1px solid ${props => props.$color}30;
  border-left: 4px solid ${props => props.$color};
  border-radius: 12px;
  padding: 1.5rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px ${props => props.$color}20;
    border-color: ${props => props.$color};
  }

  ${props => props.$alert && `
    animation: pulse 2s infinite;

    @keyframes pulse {
      0%, 100% {
        border-color: ${props.$color}60;
        box-shadow: 0 0 0 0 ${props.$color}40;
      }
      50% {
        border-color: ${props.$color};
        box-shadow: 0 0 0 8px ${props.$color}00;
      }
    }
  `}
`;
const StatIcon = styled.div `
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 2rem;
  color: ${props => props.$color}40;
  opacity: 0.3;
`;
const StatLabel = styled.div `
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-tertiary);
  font-weight: 600;
  margin-bottom: 0.5rem;
`;
const StatValue = styled.div `
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  font-family: 'JetBrains Mono', monospace;
  margin-bottom: 0.5rem;
  line-height: 1;
`;
const StatSubtitle = styled.div `
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-tertiary);
  margin-top: 0.25rem;
`;
const AlertBadge = styled.div `
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: #ef444420;
  color: #ef4444;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 0.5rem;

  svg {
    font-size: 0.75rem;
  }
`;
export const DashboardStats = ({ stats }) => {
    return (_jsx(StatsGrid, { children: stats.map((stat, index) => (_jsxs(StatCard, { "$color": stat.color, "$alert": stat.alert, children: [_jsx(StatIcon, { "$color": stat.color, children: stat.icon }), _jsx(StatLabel, { children: stat.label }), _jsxs(StatValue, { children: [stat.suffix === '%' && stat.suffix, stat.suffix === '$' && '$', stat.value.toLocaleString(), stat.suffix === '/d' && '/d'] }), stat.subtitle && (_jsx(StatSubtitle, { children: stat.subtitle })), stat.alert && (_jsxs(AlertBadge, { children: [_jsx(FaExclamationTriangle, {}), "Action Required"] }))] }, index))) }));
};
